import { Accordion, AccordionSummary, Box, LinearProgress, linearProgressClasses, Button } from '@mui/material'
import React, { useEffect } from 'react'
import CheckIcon from '@mui/icons-material/Check';
import { MenuIcon } from '../../../../../core/icon/__refactored/Icon';
import { rqx } from '../../../../../core/request/API';
import { env } from '../../../../../core/Env';

export const Info = ({openWidth, wideHandler,cid, __LOCATION, information_state, uid, tool_state}) => {
    let urlParams = new URLSearchParams(window.location.search);
    const info = information_state.info
    const inf = information_state.info.data.data
    const tc = information_state.tc
    const trainingId = parseInt(urlParams.get("id"), 10);
    
    const _init = async () => {
        const courseData = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_view_course`, { course_id: cid, company_id: tool_state.cinfo.data[0].company_id });
        const allTrainingIds = courseData[0].trainings.map(t => t.training_id).join(',');
    
        const status = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_training_status`, {
            training_id: allTrainingIds,
            user_id: uid,
            course_id: courseData[0].course_id,
            ref: 'course',
            company_id: tool_state.cinfo.data[0].company_id
        });
    
        const tContent = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_training_content`, {
            training_id: allTrainingIds,
            ref: 'course'
        });
    
        const progress = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_check_trainings`, {
            training_id: allTrainingIds,
            user_id: uid,
            ref: 'course',
            course_id: cid,
            company_id: tool_state.cinfo.data[0].company_id
        });
    
        const fields = ['pretest_id', 'quiz_id', 'post_evaluation_id'];
    
        // Progress percentage calculation
        const countNonNull = tContent.reduce((acc, training) => {
            const stepCount = fields.reduce((sum, field) => sum + (training[field] !== null ? 1 : 0), 0);
            return acc + stepCount + 1; // +1 for video lesson
        }, 0);
    
        const progressCount = progress.filter(item => item.progress_status === 1).length;
        const percentage = (progressCount / (countNonNull / 100)).toFixed(2);
    
        // ✅ STEP 1: Get trainingId from URL and ensure it's a number
        const trainingId = parseInt(urlParams.get('id')); // Make sure to use parseInt
        const currentTraining = tContent.find(t => t.training_id === trainingId);
        const currentProgress = progress.filter(p => parseInt(p.training_id) === trainingId);

    
        // ✅ STEP 2: Initialize flags
        let pretest = currentTraining?.pretest_id !== null ? 0 : null;
        let quiz = currentTraining?.quiz_id !== null ? 0 : null;
        let posteval = currentTraining?.post_evaluation_id !== null ? 0 : null;
    
        // ✅ STEP 3: Set progress flags based on currentProgress
        currentProgress.forEach(item => {
            if (item.exam_type === 1 && pretest !== null) pretest = item.progress_status;
            if (item.exam_type === 2 && quiz !== null) quiz = item.progress_status;
            if (item.exam_type === 3 && posteval !== null) posteval = item.progress_status;
        });
    
        const currentVL = currentProgress.find(p => p.exam_type === 4)?.progress_status || 0;
    
        // ✅ STEP 4: Set progress for current training only
        information_state.prog.set({
            pretest: pretest ?? 0,
            quiz: quiz ?? 0,
            posteval: posteval ?? 0,
            vl: currentVL
        });
    
        tc.set({
            ...tc.data,
            status: status.status,
            progress: percentage,
            pretest: pretest ?? 0,
            quiz: quiz ?? 0,
            posteval: posteval ?? 0
        });
    
        // ✅ Optional full training progress map
        const trainingProgressMap = [];
        tContent.forEach(training => {
            const entry = {
                training_id: training.training_id,
                pretest: training.pretest_id !== null ? 0 : null,
                quiz: training.quiz_id !== null ? 0 : null,
                posteval: training.post_evaluation_id !== null ? 0 : null,
                vl: 0,
                completed: false
            };
            trainingProgressMap.push(entry);
        });
    
        progress.forEach(p => {
            const target = trainingProgressMap.find(t => t.training_id === p.training_id);
            if (!target) return;
            if (p.exam_type === 1 && target.pretest !== null) target.pretest = p.progress_status;
            if (p.exam_type === 2 && target.quiz !== null) target.quiz = p.progress_status;
            if (p.exam_type === 3 && target.posteval !== null) target.posteval = p.progress_status;
            if (p.exam_type === 4) target.vl = p.progress_status;
        });
    
        trainingProgressMap.forEach(t => {
            const steps = ['pretest', 'quiz', 'posteval'];
            const allStepsDone = steps.every(step => t[step] === null || t[step] === 1);
            t.completed = allStepsDone;
        });
    
        info.set({
            ...info.data,
            data: courseData
        });
    };
    
    
    useEffect(() => {
        _init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trainingId])

    return (
        inf.length > 0 && (
            <Box display="flex" flexDirection="column" sx={{ width: openWidth.data ? '479px' : '0px', transition: 'width 0.3s ease', boxShadow: '0px 0px 4px rgba(233, 240, 251, 1)', py: openWidth.data && '40px', px: openWidth.data && '38px', }}>
                <Box display="flex" className='c-pointer' onClick={wideHandler} mb="40px">
                    <MenuIcon />
                    <Box fontSize={14} fontWeight={600} lineHeight="22.65px" color="#1893F1" ml="12px">Hide menu</Box>
                </Box>
                <Box fontSize={24} fontWeight={700} lineHeight="38px">
                    {inf[0].title}
                </Box>
                <Box fontSize={14} fontWeight={400} lineHeight="23px">
                    {inf[0].description}
                </Box>
                
                <Box mt="40px">
                    {/* Pretest */}
                    {tc.data.pretest !== null && (
                        <Box display="flex" justifyContent="space-between" bgcolor={__LOCATION === '/take-course/pretest' && '#E9F0FB'} border="1px solid #E9F0FB" borderRadius="8px" p="16px">
                            <Box fontSize={14} fontWeight={400} lineHeight="23px" color={__LOCATION === '/take-course/pretest' ? "#1893F1" : "#B1C2D2"}>Pretests</Box>
                            {information_state.prog.data?.pretest === 1 && (
                                <Box display="flex" justifyContent="center" alignItems="center" width="20px" height="20px" borderRadius="50%" p="2px" bgcolor="#0D62BE">
                                    <CheckIcon sx={{ color: "#fff", height: "12px", width: "12px" }} size="small" />
                                </Box>
                            )}
                        </Box>
                    )}
                    {/* Video Lesson */}
                    {inf[0].mode_of_conduct !== 2 && (
                        <Box display="flex" justifyContent="space-between" bgcolor={__LOCATION === '/take-course/video-lesson' && '#E9F0FB'} border="1px solid #E9F0FB" borderRadius="8px" p="16px" mt="12px">
                            <Box fontSize={14} fontWeight={400} lineHeight="23px" color={__LOCATION === '/take-course/video-lesson' ? "#1893F1" : "#B1C2D2"}>Video Lesson</Box>
                            {information_state.prog.data?.vl === 1 && (
                                <Box display="flex" justifyContent="center" alignItems="center" width="20px" height="20px" borderRadius="50%" p="2px" bgcolor="#0D62BE">
                                    <CheckIcon sx={{ color: "#fff", height: "12px", width: "12px" }} size="small" />
                                </Box>
                            )}
                        </Box>
                    )}
                    {/* Quiz */}
                    {tc.data.quiz !== null && (
                        <Box display="flex" justifyContent="space-between" bgcolor={__LOCATION === '/take-course/quiz' && '#E9F0FB'} border="1px solid #E9F0FB" borderRadius="8px" p="16px" mt="12px">
                            <Box fontSize={14} fontWeight={400} lineHeight="23px" color={__LOCATION === '/take-course/quiz' ? "#1893F1" : "#B1C2D2"}>Quiz</Box>
                            {information_state.prog.data?.quiz === 1 && (
                                <Box display="flex" justifyContent="center" alignItems="center" width="20px" height="20px" borderRadius="50%" p="2px" bgcolor="#0D62BE">
                                    <CheckIcon sx={{ color: "#fff", height: "12px", width: "12px" }} size="small" />
                                </Box>
                            )}
                        </Box>
                    )}
                    {/* Post Evaluation */}
                    {tc.data.posteval !== null && (
                        <Box display="flex" justifyContent="space-between" bgcolor={__LOCATION === '/take-course/post-evaluation' && '#E9F0FB'} border="1px solid #E9F0FB" borderRadius="8px" p="16px" mt="12px">
                            <Box fontSize={14} fontWeight={400} lineHeight="23px" color={__LOCATION === '/take-course/post-evaluation' ? "#1893F1" : "#B1C2D2"}>Post Evaluation</Box>
                            {information_state.prog.data?.posteval === 1 && (
                                <Box display="flex" justifyContent="center" alignItems="center" width="20px" height="20px" borderRadius="50%" p="2px" bgcolor="#0D62BE">
                                    <CheckIcon sx={{ color: "#fff", height: "12px", width: "12px" }} size="small" />
                                </Box>
                            )}
                        </Box>
                    )}
                </Box>
            </Box>
        )
    )
}   

